<template>
  <section id="section-contact" class="contact-section" style="min-height: 700px !important;padding-top: 0;">
    <div class="contact-background">
      <div class="bg-overlay"></div>
    </div>
    <div class="contact-content-wrapper">
      <div class="contact-intro">
        <h1>Get in Touch</h1>
        <p>
          To get in touch with us, please fill out the form below with your contact information
          and a brief message outlining your inquiry.
        </p>
      </div>
    </div>
  </section>

  <section id="contact-form" class="contact-section" style="margin-top: -20%;">
    <div class="contact-content-wrapper">
      <div class="contact-card">
        <div class="form-panel">
          <h2>Send us a Message</h2>

          <form class="contact-form" @submit.prevent="submitForm">

            <!-- Honeypot (hidden field for bots) -->
            <input
              type="text"
              v-model="form.website"
              autocomplete="off"
              tabindex="-1"
              class="honeypot"
            />

            <div class="form-row">
              <div class="form-group">
                <label for="name">Name</label>
                <input v-model="form.name" type="text" id="name" placeholder="John Doe">
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                <input v-model="form.email" type="email" id="email" placeholder="johndoe1992@gmail.com">
              </div>
            </div>

            <div class="form-group">
              <label for="message">Message</label>
              <textarea v-model="form.message" id="message" rows="5" placeholder="How can we help?"></textarea>
            </div>

            <div class="form-footer">
              <button type="submit" class="btn-submit" :disabled="isSubmitting">
                {{ isSubmitting ? 'Sending...' : 'Send message' }}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M21.4267 11.0952L4.42674 3.09517C4.25556 3.01462 4.06503 2.98428 3.8773 3.00768C3.68956 3.03108 3.51232 3.10725 3.36614 3.22735C3.21996 3.34745 3.11086 3.50656 3.05149 3.68619C2.99212 3.86582 2.98492 4.05861 3.03074 4.24217L4.24274 9.09117L12.0007 12.0002L4.24274 14.9092L3.03074 19.7582C2.98406 19.9419 2.99066 20.135 3.04975 20.3151C3.10885 20.4952 3.218 20.6547 3.36444 20.7751C3.51088 20.8954 3.68855 20.9715 3.87667 20.9946C4.0648 21.0176 4.25559 20.9866 4.42674 20.9052L21.4267 12.9052C21.5985 12.8244 21.7438 12.6964 21.8455 12.5362C21.9473 12.3759 22.0013 12.19 22.0013 12.0002C22.0013 11.8103 21.9473 11.6244 21.8455 11.4642C21.7438 11.3039 21.5985 11.1759 21.4267 11.0952Z" fill="white"/>
                </svg>
              </button>
            </div>

          </form>
        </div>

        <!-- INFO PANEL (unchanged) -->
        <div class="info-panel">
          <h3>Contact information</h3>
          <div class="info-block">
            <svg xmlns="http://www.w3.org/2000/svg" width="59" height="50" viewBox="0 0 59 50" fill="none">
              <g clip-path="url(#clip0_348_22340)">
                <path d="M25.4202 39.9691C25.7911 40.9796 26.1621 41.9902 26.5308 43.003C26.7221 43.5305 26.9433 44.0486 27.0354 44.6087C27.1944 45.5913 26.4179 46.3194 25.4639 46.0814C24.9847 45.9623 24.586 45.6869 24.2358 45.3555C23.3256 44.4944 22.427 43.6215 21.5237 42.751C20.9983 42.2422 20.708 41.5794 20.4038 40.9329C20.2241 40.5502 19.9891 40.4475 19.6296 40.6505C18.5305 41.2713 17.3784 41.3647 16.1848 40.9913C15.8368 40.8816 15.6064 40.9913 15.4198 41.3017C14.9843 42.0275 14.3506 42.5083 13.5579 42.7743C12.7192 43.0567 12.1454 43.6845 11.5809 44.3217C11.2744 44.6694 10.9772 45.0241 10.6892 45.3882C9.48405 46.9122 8.01164 47.7477 6.02078 47.2599C5.54841 47.1433 5.06913 47.1526 4.58985 47.1643C3.82485 47.1829 3.19348 46.9052 2.72572 46.3054C2.23492 45.6729 1.64043 45.1642 1.02289 44.6671C0.0850674 43.9109 -0.237526 42.954 0.16802 41.8175C0.882334 39.8197 1.91002 37.9713 3.11514 36.2419C3.93314 35.0703 5.19587 34.7716 6.55076 35.2384C7.51623 35.5698 8.40797 36.0692 9.32736 36.501C9.70296 36.6784 9.89882 36.662 10.0809 36.2536C10.3297 35.7005 10.5233 35.1567 10.514 34.5289C10.4979 33.1939 11.1892 32.2161 12.1754 31.4226C12.8644 30.8695 13.5741 30.342 14.3783 29.7259C13.6109 29.8169 12.9681 29.9056 12.3206 29.9639C11.2883 30.0596 10.2537 30.0689 9.22367 29.9336C8.01165 29.7725 7.32268 28.7783 7.56232 27.5507C7.71901 26.7432 8.04621 26.0011 8.38493 25.2589C8.65914 24.6615 8.89417 24.043 9.20294 23.4619C9.86195 22.2179 10.0809 20.9367 9.79743 19.534C9.33197 17.2212 10.6592 16.0076 12.8183 15.8886C13.2999 15.8629 13.7768 15.9259 14.2423 16.0496C15.9359 16.4954 16.7493 17.7136 16.2562 19.541C15.8599 21.016 16.1249 22.3206 16.565 23.6813C16.9613 24.9065 17.2217 26.1574 16.7608 27.4434C16.6272 27.8121 16.4152 28.1319 16.1502 28.5613C16.5488 28.3302 16.8645 28.1645 17.2424 28.2019C17.7286 28.2486 18.0719 28.4819 18.2632 28.9324C18.466 29.4131 18.3761 29.8542 18.0259 30.2206C17.8553 30.398 17.6411 30.5427 17.4314 30.6711C16.0696 31.5089 14.793 32.4681 13.5556 33.4833C13.1524 33.8147 12.9266 34.1928 12.975 34.7319C13.0441 35.4928 12.8045 36.1953 12.4934 36.8651C12.1846 37.5325 11.8413 38.1837 11.4841 38.8255C11.0694 39.5723 10.5071 39.7683 9.73982 39.4183C8.5877 38.8908 7.44941 38.3284 6.3042 37.7893C5.34564 37.3388 5.18895 37.3762 4.65437 38.312C3.95388 39.5373 3.26031 40.7649 2.67733 42.0578C2.46304 42.5316 2.53678 42.807 2.94923 43.0707C3.35478 43.3321 3.73037 43.6542 4.00688 44.0463C4.33639 44.5177 4.74193 44.7254 5.30647 44.7277C5.80188 44.7277 6.3019 44.7861 6.7904 44.8701C7.4978 44.9891 8.00704 44.6974 8.45636 44.1863C9.14303 43.4045 9.84582 42.6343 10.5463 41.8618C11.074 41.2807 11.7053 40.8466 12.4381 40.5759C12.9035 40.4032 13.2768 40.1371 13.5556 39.7123C14.2884 38.5921 15.3023 38.186 16.588 38.5641C17.3231 38.7788 18.012 38.7345 18.701 38.3727C19.0351 38.1977 19.4176 38.0833 19.7909 38.0226C20.9039 37.8453 21.7334 38.2957 22.2887 39.2759C22.5214 39.6867 22.7265 40.1114 23.003 40.5035C22.9178 40.1301 22.8256 39.759 22.7495 39.3833C22.4131 37.7239 23.6505 36.564 25.2796 37.0144C25.7289 37.1381 26.1345 37.3552 26.5239 37.6049C28.2175 38.6901 29.6185 40.0764 30.6669 41.8128C30.9642 42.3052 31.0817 42.849 31.0448 43.4301C31.0287 43.6985 30.9987 43.9809 31.1877 44.212C31.8628 45.0381 32.3651 45.981 32.9573 46.8609C33.0864 47.0522 33.2292 47.4793 33.5196 47.2693C33.7569 47.0966 33.8191 46.6835 33.6186 46.3614C33.4458 46.0837 33.243 45.8223 33.0518 45.5563C31.955 44.0509 32.4089 42.6366 34.1901 42.0998C34.886 41.8898 35.6049 41.7544 36.3146 41.5934C36.7501 41.4954 36.886 41.318 36.6441 40.8653C36.2616 40.1488 36.2754 39.3623 36.4552 38.5944C36.757 37.3038 37.3008 36.0972 37.8607 34.9093C38.4852 33.5837 39.5981 33.2196 40.8747 33.9454C41.6719 34.3982 42.324 34.4332 43.1052 33.9454C44.3195 33.1869 45.6191 33.2453 46.921 33.7517C47.2966 33.8988 47.6837 34.0178 48.0455 34.1952C49.193 34.7576 50.3774 34.858 51.6286 34.6433C52.7139 34.4566 53.8176 34.3749 54.9997 34.2372C54.343 33.9734 53.7692 33.7144 53.2761 33.3153C51.6516 32.0014 51.1124 29.9803 51.8498 27.9778C52.0111 27.5414 52.1862 27.112 52.3751 26.6872C52.571 26.2485 52.5226 25.854 52.2092 25.4993C51.6332 24.8505 51.0525 24.204 50.4695 23.5599C49.6446 22.6474 49.6792 21.9799 50.6124 21.2027C51.6792 20.3159 52.7231 19.401 53.8545 18.5982C53.9558 18.5258 54.1402 18.4721 54.0757 18.3064C54.0227 18.1757 53.8521 18.1711 53.7185 18.1664C53.0042 18.1524 52.306 18.0334 51.6286 17.8117C50.5294 17.4546 49.9972 16.7311 49.9787 15.5735C49.9741 15.3565 49.9396 15.2164 49.7368 15.1068C49.0386 14.7217 48.7091 14.0775 48.6077 13.312C48.5155 12.6142 48.216 12.0261 47.8289 11.459C47.0961 10.3877 46.2804 9.38187 45.4325 8.40633C44.4463 7.27208 44.1421 5.96747 44.3702 4.50883C44.437 4.08407 44.4416 3.65931 44.4232 3.23222C44.4094 2.86581 44.2343 2.59509 43.8886 2.48073C43.5223 2.35937 43.3126 2.60676 43.1444 2.87981C42.9831 3.14354 42.831 3.41426 42.6996 3.69432C41.4392 6.35255 40.0912 8.96878 38.9875 11.7017C38.6165 12.6212 38.1165 13.4707 37.3653 14.1429C36.5012 14.9154 35.5335 15.0787 34.4827 14.6283C33.4735 14.1966 33.0472 13.3354 32.9343 12.2875C32.8652 11.6527 32.8237 11.0155 32.8951 10.3714C32.9596 9.81129 32.7476 9.3912 32.1577 9.23484C31.455 9.04813 30.7499 8.86142 30.054 8.65371C29.713 8.55102 29.5655 8.7564 29.4019 8.98278C28.1599 10.7075 26.8787 12.4042 25.752 14.2129C24.7243 15.8582 23.5399 17.3379 21.7334 18.1734C21.45 18.3041 21.2979 18.5258 21.2472 18.8432C21.1527 19.4173 21.0582 19.9891 21.0398 20.5726C21.0283 20.9343 21.1596 21.0043 21.496 20.8713C22.9661 20.2855 23.5169 20.4582 24.3763 21.7792C24.5422 22.0359 24.6897 22.0032 24.8948 21.8749C25.487 21.4991 25.8649 20.3835 25.5308 19.7581C25.0215 18.8035 25.116 17.891 25.5838 16.9808C26.0907 15.9959 26.6691 15.0601 27.5723 14.3786C28.9618 13.3307 30.5655 13.6411 31.4596 15.1511C31.7453 15.6342 31.9826 16.1453 32.1577 16.6821C32.2499 16.9645 32.379 17.1512 32.7108 17.1699C32.9827 17.1862 33.22 17.3379 33.402 17.5526C33.9274 18.1757 34.2869 18.9016 34.3237 19.7067C34.3675 20.715 33.7338 21.3428 32.8974 21.7792C32.5564 21.9566 32.1854 22.0872 31.8766 22.309C31.1139 22.8597 30.6393 23.6066 30.4826 24.5634C30.1669 26.4935 29.0171 27.7118 27.2336 28.3606C26.5055 28.6266 25.881 28.3769 25.5999 27.7258C25.3234 27.084 25.5884 26.4538 26.2889 26.1014C26.4087 26.0408 26.5354 25.9964 26.6575 25.9404C27.4433 25.581 27.9617 25.0069 28.0931 24.1177C28.3512 22.372 29.3005 21.0837 30.7199 20.1292C31.0287 19.9238 31.0402 19.8141 30.8236 19.5177C30.2637 18.7429 29.9895 17.821 29.6254 16.9458C29.3074 16.1827 29.1669 16.1546 28.6254 16.7708C28.4226 17.0018 28.2405 17.2539 28.0746 17.5129C27.7659 17.9937 27.6023 18.4325 27.8788 19.0673C28.7475 21.0627 27.0631 24.3767 24.8003 24.4841C23.8971 24.5261 23.139 24.26 22.5399 23.5762C22.3532 23.3638 22.1942 23.2962 21.9016 23.3685C19.9822 23.84 18.6273 22.7921 18.5835 20.792C18.5581 19.6997 18.7632 18.6285 19.0674 17.5829C19.2425 16.9762 19.6342 16.5001 20.1941 16.2457C21.9039 15.4662 22.9938 14.0729 23.9501 12.5162C25.146 10.5698 26.5608 8.7774 27.8742 6.91267C28.4295 6.12384 29.1392 5.85078 30.077 6.11684C31.0356 6.3899 32.0195 6.5556 32.9619 6.89867C34.6348 7.51013 35.3053 8.46 35.3099 10.2617C35.3099 10.7285 35.3053 11.1929 35.3146 11.6597C35.3192 11.9071 35.2754 12.2338 35.5565 12.3155C35.8353 12.3948 35.9736 12.0891 36.1141 11.8931C36.4874 11.3703 36.7478 10.7868 36.9874 10.194C38.1465 7.33743 39.5382 4.59285 40.9254 1.84593C41.5291 0.653338 42.4784 -0.0701491 43.8702 -0.00246803C45.5984 0.0815499 46.8311 1.41183 46.9026 3.25789C46.9164 3.58463 46.891 3.91837 46.8357 4.24277C46.6261 5.46803 46.8841 6.49258 47.7736 7.42845C48.8082 8.51602 49.7322 9.71794 50.4396 11.0646C50.5202 11.2186 50.6078 11.3726 50.6585 11.5383C50.882 12.2898 51.0825 12.9923 51.9097 13.3914C52.465 13.6598 52.6194 14.3553 52.541 14.9807C52.4788 15.4825 52.7162 15.5875 53.1033 15.6272C53.4835 15.6669 53.8637 15.7229 54.2462 15.7532C55.578 15.8512 56.4122 16.409 56.6979 17.4079C56.9997 18.4535 56.5527 19.7231 55.5619 20.4209C54.7577 20.9857 54.0088 21.6228 53.2323 22.2226C52.9189 22.4653 52.9212 22.6357 53.1908 22.9064C53.518 23.2332 53.8107 23.5926 54.1056 23.9496C55.0803 25.1306 55.2278 26.4072 54.5665 27.7981C54.336 28.2836 54.1102 28.7783 54.025 29.3268C53.8683 30.3257 54.2047 31.0725 55.0688 31.5719C55.5596 31.8543 56.0988 31.9734 56.6495 32.0737C57.479 32.2231 58.2532 32.4868 58.7118 33.2873C59.2418 34.2138 59.0321 35.2804 58.1933 35.9385C57.3062 36.634 56.2393 36.7204 55.1909 36.767C53.8291 36.8277 52.4857 37.0214 51.1378 37.2105C50.0939 37.3552 49.0755 37.2455 48.0869 36.8581C47.3911 36.585 46.6883 36.3236 45.9924 36.0529C45.3679 35.8078 44.7619 35.8008 44.172 36.1649C44.0246 36.2559 43.861 36.3189 43.7135 36.4053C42.6098 37.0518 41.4922 37.0844 40.3793 36.4473C40.0475 36.2583 39.8839 36.2979 39.7502 36.6784C39.5152 37.3552 39.2341 38.0156 38.9668 38.6808C38.7525 39.2129 38.7663 39.7053 39.0543 40.2328C39.7825 41.5677 39.5037 42.5573 38.2386 43.4091C37.499 43.9086 36.651 44.0743 35.8077 44.2446C35.4113 44.324 35.2593 44.422 35.5565 44.8304C36.386 45.9717 36.3238 47.1946 35.7385 48.4059C34.8353 50.2799 32.9066 50.5366 31.5149 48.9963C31.0586 48.4922 30.713 47.9064 30.3581 47.3323C30.0125 46.7722 29.6623 46.2167 29.2383 45.7126C28.7521 45.1362 28.5562 44.4523 28.5862 43.7149C28.6069 43.1921 28.4571 42.7743 28.1322 42.3846C27.3534 41.4557 26.517 40.5969 25.5446 39.885L25.4202 39.9691ZM11.5901 27.5251C12.2422 27.5367 13.0049 27.4994 13.74 27.2497C14.2677 27.07 14.5419 26.7106 14.5442 26.1178C14.5442 25.4853 14.4151 24.8878 14.2123 24.2997C13.6202 22.5937 13.2123 20.8783 13.899 19.0883C13.975 18.8876 14.0004 18.6355 13.763 18.5235C13.3114 18.3111 12.8045 18.2761 12.3759 18.4908C12.0049 18.6775 12.1616 19.1233 12.233 19.443C12.5717 20.9367 12.4104 22.3603 11.7514 23.7396C11.3597 24.5588 11.0187 25.4013 10.6385 26.2275C10.0417 27.5297 10.0348 27.5274 11.4173 27.5227C11.4357 27.5227 11.4565 27.5227 11.5924 27.5227L11.5901 27.5251Z" fill="white"/>
                <path d="M20.713 27.7605C20.7061 27.0627 21.1969 26.5236 21.8674 26.4979C22.5356 26.4722 23.114 27.0533 23.1071 27.7442C23.1002 28.3813 22.5679 28.9344 21.9457 28.9507C21.2867 28.9694 20.7222 28.421 20.7153 27.7605H20.713Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_348_22340">
                  <rect width="59" height="50" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <div class="info-text">
              <h4>EDCTP EUROPE</h4>
              <p>T: +31 70 344 0800</p>
            </div>
          </div>
          <div class="info-block">
            <svg xmlns="http://www.w3.org/2000/svg" width="59" height="62" viewBox="0 0 59 62" fill="none">
              <g clip-path="url(#clip0_348_22344)">
                <mask id="path-1-outside-1_348_22344" maskUnits="userSpaceOnUse" x="-1" y="-0.999023" width="57" height="64" fill="black">
                  <rect fill="white" x="-1" y="-0.999023" width="57" height="64"/>
                  <path d="M27.9267 6.28357C27.9586 6.10444 27.9807 6.03183 27.9857 5.95679C28.0865 4.56007 29.0059 3.80967 30.417 3.96944C31.1077 4.04932 31.8084 4.1292 32.4525 4.38579C34.2175 5.08777 36.022 4.90865 37.8337 4.69805C38.0771 4.669 38.323 4.6448 38.5663 4.63753C40.4199 4.5867 41.3246 5.4194 41.4401 7.27362C41.4844 7.98045 41.4106 8.68243 41.3147 9.37958C41.2017 10.2292 41.5286 10.9143 42.0744 11.5291C42.2219 11.6961 42.362 11.8801 42.5415 12.006C43.9599 13.0178 44.6458 14.429 44.8818 16.092C44.9064 16.2712 44.9752 16.443 45.0047 16.6222C45.1891 17.7114 45.7373 18.5175 46.8067 18.9484C47.731 19.3188 48.3825 20.0207 48.9602 20.7857C49.3977 21.3666 49.9214 21.5457 50.6171 21.3424C51.421 21.1076 52.2224 20.8728 53.0385 20.6816C54.8921 20.2507 55.9345 21.3158 55.7845 23.1845C55.5362 26.2587 53.8621 28.5487 51.8831 30.7248C50.9662 31.7318 50.0467 32.7558 48.9061 33.5013C47.3131 34.5398 46.8632 36.0333 46.8485 37.7568C46.8337 39.5868 46.7747 41.4096 47.0402 43.2396C47.3868 45.6287 46.551 47.0351 44.3508 48.1317C44.277 48.168 44.2057 48.2043 44.132 48.2406C42.7504 48.9208 42.7308 48.9983 42.9225 50.47C43.2347 52.8762 42.5734 55.0112 40.6067 56.5047C38.7138 57.9402 36.9168 59.5112 34.8911 60.7723C33.7554 61.4791 32.5631 62.0383 31.1692 61.9996C30.0482 61.9681 29.0526 61.5711 28.1528 60.9466C27.5284 60.5157 27.2482 59.8621 27.1449 59.1432C27.049 58.4921 26.8253 57.9038 26.459 57.3544C25.9502 56.587 25.5912 55.7519 25.5027 54.832C25.3749 53.4934 24.8169 52.3267 24.1138 51.1962C23.2067 49.739 22.7273 48.1535 22.833 46.4276C22.8502 46.1492 22.8846 45.8636 22.9608 45.5949C23.1477 44.951 23.7352 44.5685 24.3449 44.6557C25.0012 44.7501 25.5544 45.2923 25.4585 45.9604C25.2102 47.7153 25.8567 49.1871 26.7565 50.6225C27.4965 51.8014 27.9365 53.0964 28.0619 54.4835C28.116 55.0838 28.3864 55.6042 28.7084 56.098C29.205 56.8533 29.5393 57.6594 29.6672 58.5574C29.7458 59.1069 30.7488 59.5717 31.5281 59.4506C32.2312 59.3417 32.8458 59.0367 33.4382 58.6688C34.7067 57.8845 35.8302 56.9114 37.0077 56.0109C37.492 55.6405 37.9788 55.2702 38.4877 54.9361C40.0635 53.9001 40.6068 52.4211 40.3339 50.6443C40.002 48.4996 40.5527 47.2845 42.4554 46.2242C42.7209 46.0766 42.9889 45.9168 43.274 45.8127C44.223 45.4617 44.5794 44.7936 44.4663 43.8254C44.2721 42.1454 44.1197 40.4631 44.2033 38.7686C44.2525 37.7641 44.3115 36.7595 44.4614 35.7646C44.6925 34.242 45.4103 32.993 46.6641 32.0586C48.5914 30.6256 50.1746 28.8682 51.6422 26.997C52.3576 26.0845 52.8345 25.0847 53.0213 23.9422C53.0975 23.4774 53.073 23.2596 52.4952 23.4726C51.7307 23.7558 50.9367 23.9277 50.1058 23.9543C48.8889 23.993 47.9129 23.5597 47.1607 22.6278C46.637 21.9766 46.0815 21.3739 45.285 21.0229C43.6133 20.287 42.8586 18.8855 42.4849 17.2176C42.4357 17.0022 42.3718 16.7868 42.3423 16.5689C42.185 15.4433 41.6343 14.6009 40.7518 13.8287C39.2915 12.5506 38.3795 10.9603 38.7679 8.90271C38.8417 8.51057 38.8072 8.09906 38.8294 7.69723C38.8466 7.34382 38.7188 7.18647 38.323 7.23247C37.6543 7.30993 36.9782 7.32445 36.3096 7.40675C34.9673 7.57136 33.6595 7.46969 32.3836 7.01461C32.2312 6.95893 32.0714 6.9202 31.9141 6.87905C31.329 6.71929 30.9627 6.92343 30.8152 7.49148C30.5595 8.4791 29.3009 9.31664 28.2094 9.0068C26.4295 8.50089 24.6817 7.85215 23.214 6.67814C22.6314 6.21095 22.2258 5.60095 22.0955 4.85297C21.9332 3.93555 21.6112 3.14642 20.6057 2.82931C19.5069 2.48558 18.4326 2.44201 17.4247 3.08106C16.5618 3.62812 15.694 4.15341 14.6443 4.2817C14.2952 4.32285 13.9535 4.34464 13.6069 4.2817C12.7489 4.13404 11.945 4.28654 11.178 4.69321C10.4283 5.09019 9.86529 5.52833 9.83579 6.51353C9.79154 7.9635 8.94833 8.93176 7.56183 9.43525C6.61292 9.78141 5.75742 10.251 5.06171 11.0159C4.05871 12.1222 3.50804 13.347 3.63096 14.8575C3.72192 15.9613 3.38021 17.0095 3.02375 18.0406C2.04779 20.8631 2.78283 23.2184 5.01008 25.1646C6.02046 26.0457 7.06771 26.8881 8.27229 27.5126C8.5255 27.6434 8.77133 27.7716 9.08354 27.653C10.175 27.2367 11.3182 27.1859 12.4687 27.2706C13.3586 27.3359 14.1674 27.1592 14.9147 26.663C15.7186 26.128 16.6159 26.1668 17.5181 26.3362C18.7595 26.5662 19.969 26.9317 21.2425 27.0479C22.4618 27.1592 23.2534 28.355 23.101 29.621C23.0051 30.4053 22.8133 31.1751 22.479 31.8867C22.1889 32.4992 22.3094 32.8913 22.8797 33.2471C23.364 33.5497 23.7647 33.9612 24.1089 34.4187C24.5735 35.0384 24.5243 35.7525 23.986 36.2076C23.4304 36.6748 22.6486 36.6167 22.1324 36.0285C21.7661 35.6121 21.3285 35.2853 20.8983 34.9464C19.6519 33.9612 19.3692 33.022 19.8707 31.5382C20.0526 31.0032 20.2321 30.4682 20.414 29.9357C20.4902 29.713 20.4927 29.5387 20.1878 29.5072C19.0865 29.3935 18.0319 29.0473 16.9527 28.8319C16.611 28.7641 16.3184 28.8004 16.0185 28.9795C14.8852 29.6573 13.6536 29.9575 12.3261 29.8582C11.3378 29.7856 10.3766 29.8534 9.43508 30.2286C8.64104 30.5433 7.89617 30.2165 7.20783 29.8558C5.60746 29.0207 4.20621 27.912 2.88117 26.7017C0.865333 24.8475 0.00491667 22.5406 0 19.8803C0 19.1856 0.135208 18.5103 0.378583 17.8712C0.865333 16.5907 1.04233 15.2666 1.10133 13.911C1.24146 10.7642 3.12454 8.81799 5.76725 7.40433C5.83854 7.3656 5.91475 7.32929 5.99342 7.30993C6.85137 7.08965 7.33812 6.64909 7.33075 5.66873C7.32337 4.669 7.89125 3.86777 8.68283 3.26503C10.1136 2.17574 11.682 1.46165 13.5602 1.73034C14.4575 1.85863 15.1802 1.47375 15.9005 1.01383C17.9385 -0.286059 20.0502 -0.293321 22.1889 0.754818C23.4648 1.37934 24.2588 2.39602 24.4924 3.77578C24.6177 4.51892 25.0283 4.98127 25.6699 5.27901C26.4025 5.6179 27.2088 5.78492 27.9291 6.28599L27.9267 6.28357Z"/>
                </mask>
                <path d="M27.9267 6.28357C27.9586 6.10444 27.9807 6.03183 27.9857 5.95679C28.0865 4.56007 29.0059 3.80967 30.417 3.96944C31.1077 4.04932 31.8084 4.1292 32.4525 4.38579C34.2175 5.08777 36.022 4.90865 37.8337 4.69805C38.0771 4.669 38.323 4.6448 38.5663 4.63753C40.4199 4.5867 41.3246 5.4194 41.4401 7.27362C41.4844 7.98045 41.4106 8.68243 41.3147 9.37958C41.2017 10.2292 41.5286 10.9143 42.0744 11.5291C42.2219 11.6961 42.362 11.8801 42.5415 12.006C43.9599 13.0178 44.6458 14.429 44.8818 16.092C44.9064 16.2712 44.9752 16.443 45.0047 16.6222C45.1891 17.7114 45.7373 18.5175 46.8067 18.9484C47.731 19.3188 48.3825 20.0207 48.9602 20.7857C49.3977 21.3666 49.9214 21.5457 50.6171 21.3424C51.421 21.1076 52.2224 20.8728 53.0385 20.6816C54.8921 20.2507 55.9345 21.3158 55.7845 23.1845C55.5362 26.2587 53.8621 28.5487 51.8831 30.7248C50.9662 31.7318 50.0467 32.7558 48.9061 33.5013C47.3131 34.5398 46.8632 36.0333 46.8485 37.7568C46.8337 39.5868 46.7747 41.4096 47.0402 43.2396C47.3868 45.6287 46.551 47.0351 44.3508 48.1317C44.277 48.168 44.2057 48.2043 44.132 48.2406C42.7504 48.9208 42.7308 48.9983 42.9225 50.47C43.2347 52.8762 42.5734 55.0112 40.6067 56.5047C38.7138 57.9402 36.9168 59.5112 34.8911 60.7723C33.7554 61.4791 32.5631 62.0383 31.1692 61.9996C30.0482 61.9681 29.0526 61.5711 28.1528 60.9466C27.5284 60.5157 27.2482 59.8621 27.1449 59.1432C27.049 58.4921 26.8253 57.9038 26.459 57.3544C25.9502 56.587 25.5912 55.7519 25.5027 54.832C25.3749 53.4934 24.8169 52.3267 24.1138 51.1962C23.2067 49.739 22.7273 48.1535 22.833 46.4276C22.8502 46.1492 22.8846 45.8636 22.9608 45.5949C23.1477 44.951 23.7352 44.5685 24.3449 44.6557C25.0012 44.7501 25.5544 45.2923 25.4585 45.9604C25.2102 47.7153 25.8567 49.1871 26.7565 50.6225C27.4965 51.8014 27.9365 53.0964 28.0619 54.4835C28.116 55.0838 28.3864 55.6042 28.7084 56.098C29.205 56.8533 29.5393 57.6594 29.6672 58.5574C29.7458 59.1069 30.7488 59.5717 31.5281 59.4506C32.2312 59.3417 32.8458 59.0367 33.4382 58.6688C34.7067 57.8845 35.8302 56.9114 37.0077 56.0109C37.492 55.6405 37.9788 55.2702 38.4877 54.9361C40.0635 53.9001 40.6068 52.4211 40.3339 50.6443C40.002 48.4996 40.5527 47.2845 42.4554 46.2242C42.7209 46.0766 42.9889 45.9168 43.274 45.8127C44.223 45.4617 44.5794 44.7936 44.4663 43.8254C44.2721 42.1454 44.1197 40.4631 44.2033 38.7686C44.2525 37.7641 44.3115 36.7595 44.4614 35.7646C44.6925 34.242 45.4103 32.993 46.6641 32.0586C48.5914 30.6256 50.1746 28.8682 51.6422 26.997C52.3576 26.0845 52.8345 25.0847 53.0213 23.9422C53.0975 23.4774 53.073 23.2596 52.4952 23.4726C51.7307 23.7558 50.9367 23.9277 50.1058 23.9543C48.8889 23.993 47.9129 23.5597 47.1607 22.6278C46.637 21.9766 46.0815 21.3739 45.285 21.0229C43.6133 20.287 42.8586 18.8855 42.4849 17.2176C42.4357 17.0022 42.3718 16.7868 42.3423 16.5689C42.185 15.4433 41.6343 14.6009 40.7518 13.8287C39.2915 12.5506 38.3795 10.9603 38.7679 8.90271C38.8417 8.51057 38.8072 8.09906 38.8294 7.69723C38.8466 7.34382 38.7188 7.18647 38.323 7.23247C37.6543 7.30993 36.9782 7.32445 36.3096 7.40675C34.9673 7.57136 33.6595 7.46969 32.3836 7.01461C32.2312 6.95893 32.0714 6.9202 31.9141 6.87905C31.329 6.71929 30.9627 6.92343 30.8152 7.49148C30.5595 8.4791 29.3009 9.31664 28.2094 9.0068C26.4295 8.50089 24.6817 7.85215 23.214 6.67814C22.6314 6.21095 22.2258 5.60095 22.0955 4.85297C21.9332 3.93555 21.6112 3.14642 20.6057 2.82931C19.5069 2.48558 18.4326 2.44201 17.4247 3.08106C16.5618 3.62812 15.694 4.15341 14.6443 4.2817C14.2952 4.32285 13.9535 4.34464 13.6069 4.2817C12.7489 4.13404 11.945 4.28654 11.178 4.69321C10.4283 5.09019 9.86529 5.52833 9.83579 6.51353C9.79154 7.9635 8.94833 8.93176 7.56183 9.43525C6.61292 9.78141 5.75742 10.251 5.06171 11.0159C4.05871 12.1222 3.50804 13.347 3.63096 14.8575C3.72192 15.9613 3.38021 17.0095 3.02375 18.0406C2.04779 20.8631 2.78283 23.2184 5.01008 25.1646C6.02046 26.0457 7.06771 26.8881 8.27229 27.5126C8.5255 27.6434 8.77133 27.7716 9.08354 27.653C10.175 27.2367 11.3182 27.1859 12.4687 27.2706C13.3586 27.3359 14.1674 27.1592 14.9147 26.663C15.7186 26.128 16.6159 26.1668 17.5181 26.3362C18.7595 26.5662 19.969 26.9317 21.2425 27.0479C22.4618 27.1592 23.2534 28.355 23.101 29.621C23.0051 30.4053 22.8133 31.1751 22.479 31.8867C22.1889 32.4992 22.3094 32.8913 22.8797 33.2471C23.364 33.5497 23.7647 33.9612 24.1089 34.4187C24.5735 35.0384 24.5243 35.7525 23.986 36.2076C23.4304 36.6748 22.6486 36.6167 22.1324 36.0285C21.7661 35.6121 21.3285 35.2853 20.8983 34.9464C19.6519 33.9612 19.3692 33.022 19.8707 31.5382C20.0526 31.0032 20.2321 30.4682 20.414 29.9357C20.4902 29.713 20.4927 29.5387 20.1878 29.5072C19.0865 29.3935 18.0319 29.0473 16.9527 28.8319C16.611 28.7641 16.3184 28.8004 16.0185 28.9795C14.8852 29.6573 13.6536 29.9575 12.3261 29.8582C11.3378 29.7856 10.3766 29.8534 9.43508 30.2286C8.64104 30.5433 7.89617 30.2165 7.20783 29.8558C5.60746 29.0207 4.20621 27.912 2.88117 26.7017C0.865333 24.8475 0.00491667 22.5406 0 19.8803C0 19.1856 0.135208 18.5103 0.378583 17.8712C0.865333 16.5907 1.04233 15.2666 1.10133 13.911C1.24146 10.7642 3.12454 8.81799 5.76725 7.40433C5.83854 7.3656 5.91475 7.32929 5.99342 7.30993C6.85137 7.08965 7.33812 6.64909 7.33075 5.66873C7.32337 4.669 7.89125 3.86777 8.68283 3.26503C10.1136 2.17574 11.682 1.46165 13.5602 1.73034C14.4575 1.85863 15.1802 1.47375 15.9005 1.01383C17.9385 -0.286059 20.0502 -0.293321 22.1889 0.754818C23.4648 1.37934 24.2588 2.39602 24.4924 3.77578C24.6177 4.51892 25.0283 4.98127 25.6699 5.27901C26.4025 5.6179 27.2088 5.78492 27.9291 6.28599L27.9267 6.28357Z" fill="white"/>
                <path d="M27.9267 6.28357C27.9586 6.10444 27.9807 6.03183 27.9857 5.95679C28.0865 4.56007 29.0059 3.80967 30.417 3.96944C31.1077 4.04932 31.8084 4.1292 32.4525 4.38579C34.2175 5.08777 36.022 4.90865 37.8337 4.69805C38.0771 4.669 38.323 4.6448 38.5663 4.63753C40.4199 4.5867 41.3246 5.4194 41.4401 7.27362C41.4844 7.98045 41.4106 8.68243 41.3147 9.37958C41.2017 10.2292 41.5286 10.9143 42.0744 11.5291C42.2219 11.6961 42.362 11.8801 42.5415 12.006C43.9599 13.0178 44.6458 14.429 44.8818 16.092C44.9064 16.2712 44.9752 16.443 45.0047 16.6222C45.1891 17.7114 45.7373 18.5175 46.8067 18.9484C47.731 19.3188 48.3825 20.0207 48.9602 20.7857C49.3977 21.3666 49.9214 21.5457 50.6171 21.3424C51.421 21.1076 52.2224 20.8728 53.0385 20.6816C54.8921 20.2507 55.9345 21.3158 55.7845 23.1845C55.5362 26.2587 53.8621 28.5487 51.8831 30.7248C50.9662 31.7318 50.0467 32.7558 48.9061 33.5013C47.3131 34.5398 46.8632 36.0333 46.8485 37.7568C46.8337 39.5868 46.7747 41.4096 47.0402 43.2396C47.3868 45.6287 46.551 47.0351 44.3508 48.1317C44.277 48.168 44.2057 48.2043 44.132 48.2406C42.7504 48.9208 42.7308 48.9983 42.9225 50.47C43.2347 52.8762 42.5734 55.0112 40.6067 56.5047C38.7138 57.9402 36.9168 59.5112 34.8911 60.7723C33.7554 61.4791 32.5631 62.0383 31.1692 61.9996C30.0482 61.9681 29.0526 61.5711 28.1528 60.9466C27.5284 60.5157 27.2482 59.8621 27.1449 59.1432C27.049 58.4921 26.8253 57.9038 26.459 57.3544C25.9502 56.587 25.5912 55.7519 25.5027 54.832C25.3749 53.4934 24.8169 52.3267 24.1138 51.1962C23.2067 49.739 22.7273 48.1535 22.833 46.4276C22.8502 46.1492 22.8846 45.8636 22.9608 45.5949C23.1477 44.951 23.7352 44.5685 24.3449 44.6557C25.0012 44.7501 25.5544 45.2923 25.4585 45.9604C25.2102 47.7153 25.8567 49.1871 26.7565 50.6225C27.4965 51.8014 27.9365 53.0964 28.0619 54.4835C28.116 55.0838 28.3864 55.6042 28.7084 56.098C29.205 56.8533 29.5393 57.6594 29.6672 58.5574C29.7458 59.1069 30.7488 59.5717 31.5281 59.4506C32.2312 59.3417 32.8458 59.0367 33.4382 58.6688C34.7067 57.8845 35.8302 56.9114 37.0077 56.0109C37.492 55.6405 37.9788 55.2702 38.4877 54.9361C40.0635 53.9001 40.6068 52.4211 40.3339 50.6443C40.002 48.4996 40.5527 47.2845 42.4554 46.2242C42.7209 46.0766 42.9889 45.9168 43.274 45.8127C44.223 45.4617 44.5794 44.7936 44.4663 43.8254C44.2721 42.1454 44.1197 40.4631 44.2033 38.7686C44.2525 37.7641 44.3115 36.7595 44.4614 35.7646C44.6925 34.242 45.4103 32.993 46.6641 32.0586C48.5914 30.6256 50.1746 28.8682 51.6422 26.997C52.3576 26.0845 52.8345 25.0847 53.0213 23.9422C53.0975 23.4774 53.073 23.2596 52.4952 23.4726C51.7307 23.7558 50.9367 23.9277 50.1058 23.9543C48.8889 23.993 47.9129 23.5597 47.1607 22.6278C46.637 21.9766 46.0815 21.3739 45.285 21.0229C43.6133 20.287 42.8586 18.8855 42.4849 17.2176C42.4357 17.0022 42.3718 16.7868 42.3423 16.5689C42.185 15.4433 41.6343 14.6009 40.7518 13.8287C39.2915 12.5506 38.3795 10.9603 38.7679 8.90271C38.8417 8.51057 38.8072 8.09906 38.8294 7.69723C38.8466 7.34382 38.7188 7.18647 38.323 7.23247C37.6543 7.30993 36.9782 7.32445 36.3096 7.40675C34.9673 7.57136 33.6595 7.46969 32.3836 7.01461C32.2312 6.95893 32.0714 6.9202 31.9141 6.87905C31.329 6.71929 30.9627 6.92343 30.8152 7.49148C30.5595 8.4791 29.3009 9.31664 28.2094 9.0068C26.4295 8.50089 24.6817 7.85215 23.214 6.67814C22.6314 6.21095 22.2258 5.60095 22.0955 4.85297C21.9332 3.93555 21.6112 3.14642 20.6057 2.82931C19.5069 2.48558 18.4326 2.44201 17.4247 3.08106C16.5618 3.62812 15.694 4.15341 14.6443 4.2817C14.2952 4.32285 13.9535 4.34464 13.6069 4.2817C12.7489 4.13404 11.945 4.28654 11.178 4.69321C10.4283 5.09019 9.86529 5.52833 9.83579 6.51353C9.79154 7.9635 8.94833 8.93176 7.56183 9.43525C6.61292 9.78141 5.75742 10.251 5.06171 11.0159C4.05871 12.1222 3.50804 13.347 3.63096 14.8575C3.72192 15.9613 3.38021 17.0095 3.02375 18.0406C2.04779 20.8631 2.78283 23.2184 5.01008 25.1646C6.02046 26.0457 7.06771 26.8881 8.27229 27.5126C8.5255 27.6434 8.77133 27.7716 9.08354 27.653C10.175 27.2367 11.3182 27.1859 12.4687 27.2706C13.3586 27.3359 14.1674 27.1592 14.9147 26.663C15.7186 26.128 16.6159 26.1668 17.5181 26.3362C18.7595 26.5662 19.969 26.9317 21.2425 27.0479C22.4618 27.1592 23.2534 28.355 23.101 29.621C23.0051 30.4053 22.8133 31.1751 22.479 31.8867C22.1889 32.4992 22.3094 32.8913 22.8797 33.2471C23.364 33.5497 23.7647 33.9612 24.1089 34.4187C24.5735 35.0384 24.5243 35.7525 23.986 36.2076C23.4304 36.6748 22.6486 36.6167 22.1324 36.0285C21.7661 35.6121 21.3285 35.2853 20.8983 34.9464C19.6519 33.9612 19.3692 33.022 19.8707 31.5382C20.0526 31.0032 20.2321 30.4682 20.414 29.9357C20.4902 29.713 20.4927 29.5387 20.1878 29.5072C19.0865 29.3935 18.0319 29.0473 16.9527 28.8319C16.611 28.7641 16.3184 28.8004 16.0185 28.9795C14.8852 29.6573 13.6536 29.9575 12.3261 29.8582C11.3378 29.7856 10.3766 29.8534 9.43508 30.2286C8.64104 30.5433 7.89617 30.2165 7.20783 29.8558C5.60746 29.0207 4.20621 27.912 2.88117 26.7017C0.865333 24.8475 0.00491667 22.5406 0 19.8803C0 19.1856 0.135208 18.5103 0.378583 17.8712C0.865333 16.5907 1.04233 15.2666 1.10133 13.911C1.24146 10.7642 3.12454 8.81799 5.76725 7.40433C5.83854 7.3656 5.91475 7.32929 5.99342 7.30993C6.85137 7.08965 7.33812 6.64909 7.33075 5.66873C7.32337 4.669 7.89125 3.86777 8.68283 3.26503C10.1136 2.17574 11.682 1.46165 13.5602 1.73034C14.4575 1.85863 15.1802 1.47375 15.9005 1.01383C17.9385 -0.286059 20.0502 -0.293321 22.1889 0.754818C23.4648 1.37934 24.2588 2.39602 24.4924 3.77578C24.6177 4.51892 25.0283 4.98127 25.6699 5.27901C26.4025 5.6179 27.2088 5.78492 27.9291 6.28599L27.9267 6.28357Z" stroke="white" stroke-width="0.4" mask="url(#path-1-outside-1_348_22344)"/>
                <path d="M54.3408 41.1709C54.9683 40.6515 55.6939 40.4358 56.3896 40.5166C57.1319 40.6029 57.83 41.025 58.3291 41.7559C58.8594 42.5305 59.104 43.5033 59.1016 45.2637V45.2705L59.0996 45.2695C59.0148 46.6775 58.4133 48.4403 57.2236 49.959C56.5974 50.7604 56.1001 51.6132 55.6699 52.5205C55.3294 53.2374 54.9458 53.9378 54.4053 54.5439C53.5497 55.5053 52.4573 55.9737 51.1641 55.8818C50.0907 55.806 49.3474 55.3512 48.8877 54.6904C48.4304 54.0331 48.2605 53.1818 48.3105 52.3193C48.3653 51.3604 48.5997 50.42 49.0312 49.5479L49.1201 49.3594C49.5413 48.4127 49.6655 47.3956 49.8184 46.3672C49.9217 45.672 50.1243 45.0549 50.4971 44.5684C50.8717 44.0794 51.4124 43.7301 52.1777 43.5635L52.3145 43.5234C52.6171 43.4061 52.819 43.1389 53.0176 42.835C53.3669 42.2962 53.7177 41.7317 54.2158 41.2783L54.3408 41.1709ZM55.9209 43.4756C55.8833 43.4948 55.8461 43.5309 55.8086 43.583C55.7713 43.6348 55.738 43.6969 55.7041 43.7637C55.6715 43.8279 55.6371 43.9004 55.6016 43.96L55.6006 43.959C54.9916 44.9942 54.2124 45.8452 52.9785 46.2012L52.9795 46.2021C52.844 46.2415 52.7586 46.3126 52.7012 46.4033C52.6419 46.4972 52.608 46.6185 52.5879 46.7637C52.3858 48.2245 52.0896 49.6677 51.4414 51.0273C51.2317 51.4662 51.1215 51.9503 51.1143 52.4619V52.4629C51.1222 52.5274 51.1209 52.5945 51.1182 52.6543C51.1151 52.7219 51.1106 52.7815 51.1143 52.8379C51.1179 52.8929 51.1286 52.9369 51.1484 52.9727C51.1675 53.0068 51.1995 53.0399 51.2568 53.0674C51.5274 53.1974 51.8109 53.1207 52.0723 52.9248C52.5041 52.6013 52.7714 52.1461 52.998 51.6543V51.6533C53.5788 50.4002 54.283 49.2373 55.1201 48.1211C55.9884 46.9629 56.4786 45.6164 56.2695 44.124L56.2471 43.8975C56.2404 43.8215 56.2322 43.7503 56.2178 43.6865C56.1887 43.5579 56.1406 43.489 56.0527 43.4658C55.9965 43.4513 55.9554 43.458 55.9209 43.4756Z" fill="white" stroke="white" stroke-width="0.2"/>
                <path d="M25.8725 40.4857C25.875 41.195 25.3243 41.7541 24.6138 41.7614C23.9304 41.7687 23.3306 41.1756 23.3281 40.4954C23.3281 39.8104 23.9181 39.2197 24.6015 39.2197C25.3022 39.2197 25.8676 39.7862 25.87 40.4881L25.8725 40.4857Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_348_22344">
                  <rect width="59" height="62" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <div class="info-text">
              <h4>EDCTP AFRICA</h4>
              <p>T: +27 21 938 0609<br>F: +27 21 938 0569</p>
            </div>
          </div>
          <div class="social-links">
            <a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1663 0C9.03164 0 0 8.95714 0 20C0 31.0429 9.03164 40 20.1663 40C31.301 40 40.3327 31.0429 40.3327 20C40.3327 8.95714 31.301 0 20.1663 0ZM28.6866 15.6643C28.6938 15.85 28.701 16.0357 28.701 16.2286C28.701 21.9929 24.2788 28.6357 16.1907 28.6357C13.7059 28.6357 11.4012 27.9143 9.44937 26.6786C9.79508 26.7214 10.1408 26.7357 10.5009 26.7357C12.5607 26.7357 14.4549 26.0357 15.9602 24.8714C14.0372 24.8357 12.4167 23.5786 11.8549 21.8429C12.1214 21.8929 12.3951 21.9214 12.6832 21.9214C13.0865 21.9214 13.4754 21.8643 13.8427 21.7714C11.8333 21.3714 10.3136 19.6071 10.3136 17.5C10.3136 17.4786 10.3136 17.4643 10.3136 17.4429C10.9042 17.7714 11.5812 17.9643 12.3015 17.9857C11.1203 17.2071 10.3425 15.8714 10.3425 14.3571C10.3425 13.5571 10.5585 12.8071 10.9402 12.1643C13.1081 14.8 16.3491 16.5357 20.0007 16.7214C19.9287 16.4 19.8855 16.0714 19.8855 15.7286C19.8855 13.3214 21.8517 11.3714 24.2788 11.3714C25.5464 11.3714 26.6844 11.9 27.491 12.75C28.4922 12.5571 29.4356 12.1929 30.2855 11.6929C29.9542 12.7143 29.2628 13.5643 28.3553 14.1071C29.2412 14 30.0911 13.7643 30.8833 13.4214C30.2927 14.2929 29.5509 15.0643 28.6938 15.6786L28.6866 15.6643Z" fill="white"/>
            </svg></a>
            <a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
              <path d="M20.1663 0C9.03164 0 0 8.95714 0 20C0 31.0429 9.03164 40 20.1663 40C31.301 40 40.3327 31.0429 40.3327 20C40.3327 8.95714 31.301 0 20.1663 0ZM14.599 29.0786C13.389 29.0643 12.179 29.0714 10.969 29.0786C10.7746 29.0786 10.717 29.0286 10.717 28.8357C10.717 24.5571 10.717 20.2786 10.717 16C10.717 15.8214 10.7602 15.7571 10.9474 15.7643C12.1718 15.7714 13.4034 15.7714 14.6278 15.7643C14.8655 15.7643 14.8943 15.85 14.8943 16.05C14.8943 18.1786 14.8943 20.3071 14.8943 22.4429C14.8943 24.5786 14.8943 26.6714 14.8943 28.7786C14.8943 29.0143 14.8367 29.0857 14.5918 29.0786H14.599ZM12.8128 13.9286C11.4948 13.9286 10.4001 12.85 10.3929 11.5429C10.3929 10.2214 11.4804 9.13571 12.8128 9.13571C14.138 9.13571 15.2256 10.2143 15.2256 11.5214C15.2256 12.85 14.138 13.9286 12.8056 13.9286H12.8128ZM30.5592 28.8071C30.5592 29.0286 30.5016 29.0857 30.2783 29.0786C29.0683 29.0714 27.8584 29.0714 26.6484 29.0786C26.4323 29.0786 26.3891 29.0143 26.3891 28.8143C26.3891 26.5929 26.3963 24.3786 26.3891 22.1571C26.3891 21.6 26.3531 21.0429 26.1946 20.5071C25.9065 19.5143 25.1863 19.0071 24.1348 19.0571C22.7015 19.1357 21.9525 19.8357 21.7724 21.2857C21.7292 21.6286 21.7076 21.9786 21.7076 22.3286C21.7076 24.4857 21.7076 26.6429 21.7076 28.8C21.7076 29.0143 21.6572 29.0786 21.4339 29.0786C20.2168 29.0714 18.9924 29.0714 17.7752 29.0786C17.5807 29.0786 17.5231 29.0286 17.5231 28.8286C17.5231 24.5571 17.5231 20.2857 17.5231 16.0143C17.5231 15.8 17.5951 15.7571 17.7968 15.7571C18.9564 15.7643 20.1159 15.7643 21.2683 15.7571C21.4844 15.7571 21.5348 15.8214 21.5348 16.0214C21.5204 16.5286 21.5348 17.0429 21.5348 17.55C21.8157 17.2357 22.0461 16.9214 22.3342 16.6571C23.2201 15.8357 24.2572 15.4143 25.4816 15.4286C26.1514 15.4286 26.814 15.4786 27.4622 15.6643C28.9387 16.0857 29.7958 17.0929 30.2063 18.5286C30.516 19.6 30.5664 20.7 30.5736 21.8071C30.5736 24.1357 30.5736 26.4714 30.5736 28.8L30.5592 28.8071Z" fill="white"/>
            </svg></a>
            <a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
              <path d="M18.0059 23.2137L23.6236 19.9994L18.0059 16.7852V23.2137Z" fill="white"/>
              <path d="M20.1663 0C9.03164 0 0 8.95714 0 20C0 31.0429 9.03164 40 20.1663 40C31.301 40 40.3327 31.0429 40.3327 20C40.3327 8.95714 31.3082 0 20.1663 0ZM30.516 25.1571C30.2639 26.0786 29.5365 26.8071 28.6074 27.05C26.9221 27.5 20.1663 27.5 20.1663 27.5C20.1663 27.5 13.4106 27.5 11.7253 27.05C10.7962 26.8 10.0616 26.0786 9.81669 25.1571C9.36295 23.4857 9.36294 20 9.36294 20C9.36294 20 9.36295 16.5143 9.81669 14.8429C10.0688 13.9214 10.7962 13.1929 11.7253 12.95C13.4106 12.5 20.1663 12.5 20.1663 12.5C20.1663 12.5 26.9221 12.5 28.6074 12.95C29.5365 13.2 30.2711 13.9214 30.516 14.8429C30.9697 16.5143 30.9697 20 30.9697 20C30.9697 20 30.9697 23.4857 30.516 25.1571Z" fill="white"/>
            </svg></a>
          </div>
        </div>
      </div>
      <!-- Toast Notification -->
      <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 9999;">
        <div class="toast" :class="{ show: toast.show, 'bg-success': toast.type === 'success', 'bg-danger': toast.type === 'error' }" role="alert">
          <div class="toast-header" :class="{ 'bg-success': toast.type === 'success', 'bg-danger': toast.type === 'error', 'text-white': true }">
            <i class="bi me-2" :class="toast.type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'"></i>
            <strong class="me-auto">{{ toast.type === 'success' ? 'Success' : 'Error' }}</strong>
            <button type="button" class="btn-close btn-close-white" @click="toast.show = false"></button>
          </div>
          <div class="toast-body text-white">
            {{ toast.message }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import EmailService from '@/services/emails/EmailService'

export default {
  name: 'Contact',

  data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
        website: '' // honeypot
      },
      toast: {
        show: false,
        type: 'success',
        message: ''
      },
      isSubmitting: false
    }
  },

  methods: {
    showToast(type, message) {
      this.toast = {
        show: true,
        type: type,
        message: message
      }
      setTimeout(() => {
        this.toast.show = false
      }, 3000)
    },

    async submitForm() {
      // Honeypot check (bots will fill this)
      if (this.form.website) {
        console.warn('Bot submission blocked');
        return;
      }

      if (!this.form.name || !this.form.email || !this.form.message) {
        this.showToast('error','Please fill out all fields.');
        return;
      }

      this.isSubmitting = true;

      try {
        await EmailService.sendCustomEmail({
          recipients: 'info@edctpalumninetwork.org',
          subject: `Website Contact Message from ${this.form.name}`,
          body: `
            Name: ${this.form.name}
            Email: ${this.form.email}

            Message:
            ${this.form.message}          `
        });

        this.showToast('success','Thank you! Your message has been sent.');

        // Reset form
        this.form = {
          name: '',
          email: '',
          message: '',
          website: ''
        };

      } catch (error) {
        console.error(error);
        this.showToast('success','Something went wrong, please try again.');
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>
<style>

a {
  text-decoration: none;
  color: inherit;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.main-nav ul {
  display: flex;
  align-items: center;
  gap: 56px;
}

.main-nav a {
  font-weight: 700;
  font-size: 16px;
  color: var(--color-black);
  position: relative;
  padding-bottom: 8px;
}

.main-nav a.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--color-primary);
}

.eu-support span {
  font-family: var(--font-family-main);
  font-weight: 700;
  font-size: 5.8px;
  line-height: 1.2;
  color: var(--color-black);
}

@media (max-width: 1400px) {
  .main-nav ul {
    gap: 32px;
  }
  .header-actions {
    gap: 24px;
  }
}

@media (max-width: 1200px) {
  .mobile-nav-toggle span {
    width: 25px;
    height: 3px;
    background-color: var(--color-text-primary);
  }
}

/* Honeypot field (hidden from users, visible to bots) */
.honeypot {
  position: absolute;
  left: -9999px;
  height: 0;
  width: 0;
  opacity: 0;
  pointer-events: none;
}

/* CSS from section:contact */
.contact-section {
  position: relative;
  padding: 90px 80px 117px;
  min-height: 705px;
  display: flex;
  align-items: center;
}

.contact-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: var(--color-light-teal-bg);
  background-image: url('/public/71502ea105e1960dafd0d8784aba0a2ee72455a4.png');
  background-size: cover;
  background-position: center;
}

.contact-background .bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.1;
}

.contact-background .bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #009CAD;
  opacity: 0.6;
}

.contact-content-wrapper {
  width: 100%;
  max-width: 1272px;
  margin: 0 auto;
  z-index: 1;
}

.contact-intro {
  color: var(--color-white);
  max-width: 694px;
  margin-bottom: 62px;
}

.contact-intro h1 {
  font-size: 52px;
  font-weight: 700;
  line-height: 58px;
  margin: 0 0 32px;
}

.contact-intro p {
  font-size: 20px;
  line-height: 26px;
  margin: 0;
  font-weight: 400;
}

.contact-card {
  display: flex;
  border-radius: 16px;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.form-panel {
  flex: 1;
  background-color: var(--color-white);
  padding: 56px;
}

.form-panel h2 {
  font-size: 36px;
  font-weight: 700;
  line-height: 36px;
  margin: 0 0 48px;
  color: var(--color-text-primary);
}

.contact-form .form-row {
  display: flex;
  gap: 32px;
  margin-bottom: 24px;
}

.form-row .form-group {
  flex: 1;
}

.form-group {
  position: relative;
  margin-bottom: 24px;
}

.form-group label {
  position: absolute;
  top: -8px;
  left: 12px;
  background-color: var(--color-white);
  padding: 0 4px;
  font-family: var(--font-family-form);
  font-size: 12px;
  color: var(--color-primary);
}

.form-group input, .form-group textarea {
  width: 100%;
  padding: 16px;
  border-radius: 6px;
  border: 1px solid rgba(50, 71, 92, 0.22);
  font-family: var(--font-family-form);
  font-size: 16px;
  color: var(--color-text-primary);
}
.form-group input:focus, .form-group textarea:focus {
  outline: none;
  border-color: var(--color-primary);
}
.form-group input[id="name"] {
  border: 1.5px solid var(--color-primary);
}

.form-group textarea {
  resize: vertical;
}

.form-group ::placeholder {
  color: var(--color-text-secondary);
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
}

.recaptcha-placeholder img {
  border-radius: 5px;
  height: 56px;
}

.btn-submit {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 41px;
  background-color: var(--color-primary);
  color: var(--color-white);
  border: none;
  border-radius: 8px;
  font-family: var(--font-family-form);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.info-panel {
  position: relative;
  width: 434px;
  background-color: var(--color-secondary);
  padding: 56px;
  color: var(--color-white);
  overflow: hidden;
}

.info-bg-pattern {
  position: absolute;
  bottom: -20px;
  right: -45px;
  width: 276px;
  height: 233px;
  background-color: rgba(255, 255, 255, 0.16);
  mask-image: url('');
  -webkit-mask-image: url('');
  mask-size: contain;
  mask-repeat: no-repeat;
}

.info-panel h3 {
  font-size: 36px;
  font-weight: 700;
  line-height: 36px;
  margin: 0 0 76px;
  text-align: center;
  position: relative;
}

.info-block {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 40px;
  position: relative;
}

.info-block h4 {
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 8px;
}

.info-block p {
  font-size: 20px;
  line-height: 26px;
  margin: 0;
  font-weight: 400;
}

.social-links {
  display: flex;
  gap: 16px;
  margin-top: 100px;
  position: relative;
}

@media (max-width: 1200px) {
  .contact-section {
    padding: 60px 40px;
  }
  .contact-card {
    flex-direction: column;
  }
  .info-panel {
    width: 100%;
    border-radius: 0 0 16px 16px;
  }
}

@media (max-width: 768px) {
  .contact-section {
    padding: 40px 20px;
  }
  .contact-intro h1 {
    font-size: 40px;
    line-height: 48px;
  }
  .contact-intro p {
    font-size: 18px;
  }
  .form-panel {
    padding: 32px;
  }
  .form-panel h2 {
    font-size: 28px;
    margin-bottom: 32px;
  }
  .contact-form .form-row {
    flex-direction: column;
    gap: 24px;
    margin-bottom: 0;
  }
  .form-footer {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }
  .btn-submit {
    justify-content: center;
  }
  .info-panel {
    padding: 32px;
  }
  .info-panel h3 {
    font-size: 28px;
    margin-bottom: 40px;
  }
  .social-links {
    margin-top: 60px;
    justify-content: center;
  }
}

.toast-container .toast {
  min-width: 300px;
}

.toast-body {
  padding: 0.75rem 1rem;
  font-weight: 500;
}

.bg-success .toast-header,
.bg-success .toast-body {
  background-color: #198754 !important;
}

.bg-danger .toast-header,
.bg-danger .toast-body {
  background-color: #dc3545 !important;
}
</style>
